import { usePageMeta } from "@/hooks/usePageMeta";

const MAILTO =
  "mailto:shivanisharma.mktg@gmail.com?subject=Project%20Enquiry%20-%20Work%20with%20Shivani&body=Hi%20Shivani%2C%0A%0AHere%27s%20a%20bit%20about%20my%20project%3A%0A%0AName%3A%0ACompany%3A%0AService%20needed%3A%0ATimeline%3A%0A%0AProject%20details%3A";

const expectations = [
  { label: "Response time", value: "Within 24 hours on working days" },
  { label: "First call", value: "30 min · no pitch, just a real conversation" },
  { label: "Availability", value: "Limited projects per quarter — reach out early" },
  { label: "Location", value: "India-based · open to remote and global projects" },
];

export default function Contact() {
  usePageMeta({
    title: "Contact — Shivani | Get in Touch",
    description: "Ready to build something worth believing in? Tell me about your project and I'll get back within 24 hours.",
    ogTitle: "Contact — Shivani | Get in Touch",
    ogDescription: "Tell me about your project. I'll get back within 24 hours with a clear next step.",
  });
  return (
    <div data-testid="contact-page">
      {/* HERO */}
      <section className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14 pt-16 md:pt-24 pb-12">
        <p className="eyebrow mb-8">Contact · shivanisharma.mktg@gmail.com</p>
        <h1
          className="serif-display leading-[0.92] max-w-[22ch]"
          style={{ fontSize: "clamp(2.65rem, 6.6vw, 6rem)" }}
          data-testid="contact-headline"
        >
          Ready to build something <span className="serif-italic">worth believing in?</span>
        </h1>
        <div className="grid md:grid-cols-12 mt-10">
          <p
            className="md:col-span-6 md:col-start-6 text-base md:text-lg leading-relaxed"
            data-testid="contact-sub"
          >
            Tell me about your project. I&apos;ll get back to you within 24 hours with a clear
            next step.
          </p>
        </div>
      </section>

      {/* EXPECTATION STRIP */}
      <section
        className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14 pb-20 md:pb-24"
        data-testid="expectation-strip"
      >
        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-0">
          {expectations.map((e, i) => (
            <li
              key={e.label}
              data-testid={`expectation-${i + 1}`}
              className="p-7 md:p-8"
              style={{
                border: "0.5px solid rgba(26,26,26,0.45)",
                marginLeft: i > 0 && i % 4 !== 0 ? "-0.5px" : "0",
              }}
            >
              <p
                className="text-[10px] font-sans font-medium uppercase tracking-[0.22em] mb-3"
                style={{ color: "rgba(26,26,26,0.55)" }}
              >
                {e.label}
              </p>
              <p className="serif-display text-xl md:text-[1.35rem] leading-snug">
                {e.value}
              </p>
            </li>
          ))}
        </ul>
      </section>

      {/* MAILTO PROMPT */}
      <section
        className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14 pb-24 md:pb-32"
        style={{ borderTop: "0.5px solid rgba(26,26,26,0.35)" }}
        data-testid="contact-mailto-section"
      >
        <div className="pt-20 md:pt-28 grid md:grid-cols-12">
          <div className="md:col-span-10 md:col-start-2">
            <p
              className="serif-display leading-[1.18] mb-12 md:mb-16"
              style={{ fontSize: "clamp(1.5rem, 2.6vw, 2.25rem)" }}
              data-testid="contact-prompt"
            >
              Drop me a line with a bit about your project &mdash; what you&apos;re building, what you
              need, and your timeline. <span className="serif-italic">I&apos;ll get back to you within 24 hours.</span>
            </p>
            <a
              href={MAILTO}
              data-testid="contact-mailto"
              className="inline-flex items-center gap-2 text-[0.78rem] tracking-[0.18em] uppercase font-sans px-8 py-5 bg-[#1A1A1A] text-[#F5F0E8] transition-opacity hover:opacity-85"
              style={{ border: "0.5px solid #1A1A1A" }}
            >
              Send me an email
              <span aria-hidden>→</span>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
